import React from 'react';
import { Flex, useIsMobileView, StyleProps } from 'deepstash-ui';
import { StoryApiResponse } from 'api/api.types';
import StoryCard from './StoryCard';

interface StoriesCarouselProps {
  stories: StoryApiResponse[];
}

const StoriesCarousel: React.FC<StoriesCarouselProps & StyleProps> = ({
  stories,
  ...props
}) => {
  const isMobileView = useIsMobileView();

  return (
    <Flex
      flexDirection="row"
      width={'100%'}
      gridColumnGap={16}
      {...(isMobileView ? { overflow: 'scroll', px: 16, pb: 16 } : {})}
      {...props}
    >
      {stories.map((story, index) => {
        return <StoryCard key={`story-${index}`} story={story} />;
      })}
    </Flex>
  );
};

export default StoriesCarousel;
